module.exports = __webpack_public_path__ + "img/luxura_jewel-closed.4f24d7bc.svg";